import React from 'react'

const Scroll = ({ maxHeight, minHeight, overflowX, overflowY = 'scroll', ...props }) => {
  return <div style={{ minHeight, maxHeight: maxHeight || '18rem', overflowY, overflowX }} {...props} />
}

export default Scroll
